
let permissions = {
    methods: {
        getAllForDirectoryIncomeSources: function() {
            return [
                'income_source.view',
                'income_source.create',
                'income_source.update',
                'income_source.delete',
            ]
        },
        getAllForDirectoryStageAgreement: function() {
            return [
                'stage_agreement.view',
                'stage_agreement.create',
                'stage_agreement.update',
                'stage_agreement.delete',
            ]
        },
        getAllForDirectoryDistricts: function() {
            return [
                'districts.view',
                'districts.create',
                'districts.update',
                'districts.delete',
            ]
        },
        getAllForDirectoryLandPurposes: function() {
            return [
                'land_purpose.viewAny',
                'land_purpose.view',
                'land_purpose.create',
                'land_purpose.update',
                'land_purpose.delete',
            ]
        },
        getAllForDirectoryRoomTypes: function() {
            return [
                'room_type.viewAny',
                'room_type.view',
                'room_type.create',
                'room_type.update',
                'room_type.delete',
            ]
        },
        getAllForDirectoryRoomPurposes: function() {
            return [
                'room_purpose.viewAny',
                'room_purpose.view',
                'room_purpose.create',
                'room_purpose.update',
                'room_purpose.delete',
            ]
        },
        getAllForDirectoryLandOwnerships: function() {
            return [
                'land_ownership.viewAny',
                'land_ownership.view',
                'land_ownership.create',
                'land_ownership.update',
                'land_ownership.delete',
            ]
        },
        getAllForDirectoryMeetingResults: function() {
            return [
                'meeting_result.viewAny',
                'meeting_result.view',
                'meeting_result.create',
                'meeting_result.update',
                'meeting_result.delete',
            ]
        },
        getAllForDirectoryAgents: function() {
            return [
                'agent.viewAny',
                'agent.view',
                'agent.create',
                'agent.update',
                'agent.delete',
            ]
        },
        getAllForDirectories: function () {
            return this.getAllForDirectoryDistricts()
                .concat(this.getAllForDirectoryStageAgreement())
                .concat(this.getAllForDirectoryIncomeSources())
                .concat(this.getAllForDirectoryLandPurposes())
                .concat(this.getAllForDirectoryRoomTypes())
                .concat(this.getAllForDirectoryRoomPurposes())
                .concat(this.getAllForDirectoryLandOwnerships())
                .concat(this.getAllForDirectoryMeetingResults())
                .concat(this.getAllForDirectoryAgents());
        }
    }
}

export default permissions;